import { createFileRoute } from "@tanstack/react-router";
import { processUpgradeSequenceTick } from "@/server/email-sequences.functions";
import { checkCronAuth } from "@/server/cron-auth.server";

export const Route = createFileRoute("/api/public/hooks/process-upgrade-sequence")({
  server: {
    handlers: {
      POST: async ({ request }) => {
        const unauth = checkCronAuth(request, "CRON_API_SECRET");
        if (unauth) return unauth;

        try {
          const res = await processUpgradeSequenceTick({ maxRows: 100 });
          return Response.json(res);
        } catch (e: any) {
          return new Response(JSON.stringify({ ok: false, error: String(e?.message ?? e) }), {
            status: 500,
            headers: { "content-type": "application/json" },
          });
        }
      },
      GET: async () =>
        new Response(
          JSON.stringify({ ok: true, hint: "POST with apikey header to process the sequence" }),
          { headers: { "content-type": "application/json" } },
        ),
    },
  },
  component: () => null,
});
